import { useState } from 'react';
import './login.scss';
import axios from '../../axios';
import companyLogo from '../../images/001-02.svg'
import gymImage from '../../images/gym.jpg'
import { toast } from 'react-toastify';
import { connect } from 'react-redux'
import { loggMeIN, setAuth, setRole } from '../../redux/Functions/actions';
import sign from 'jwt-encode';
import jwtDecode from 'jwt-decode';

const Login = (props) => {
    console.log('logjin props', props)
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    async function handleLogin(e) {
        e.preventDefault();
        let secretKey = process.env.REACT_APP_SECRET
        let body = {
            email: email,
            password: sign(password, secretKey)
        }

        axios.post('/auth/login', body)
            .then(async (res) => {
                console.log('res', res);
                window.localStorage.setItem("data", res?.data?.token) 
                let auth = window.localStorage.getItem('data')  
                var decoded = jwtDecode(auth);
                console.log("auth", decoded)
                props?.setRole(decoded?.role);
                props?.setAuth(res?.data?.token)
                props?.loggMeIN(true)
                toast.success('Logged in successfully!');
            })
            .catch((err) => {
                console.error(err);
                toast.error('Error occurred while logging in.');
            });
    }

    return (
        <div class=" h-100 ">
            <div className="container-fluid ">

            <div className='row'>
            <div className="col-md-4 h-100 container_Body ">
                <div class="user_card">
                    <div class="d-flex justify-content-center">
                        <div class="brand_logo_container">
                            <img src={companyLogo} class="brand_logo" alt="Logo" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-center form_container">
                        <form onSubmit={handleLogin}>
                            <div class="input-group inputGroupText mb-3">
                                <div class="input-group-append inputIcon">
                                    <span class=""><i class="fas fa-user mt-1" style={{color:'#c0392b'}}></i></span>
                                </div>
                                <input type="text" name="" onChange={(e) => { setEmail(e.target.value) }} class="form-control input_user" placeholder="E-mail" />
                            </div>
                            <div class="input-group inputGroupText mb-2">
                                <div class="input-group-append inputIcon">
                                    <span class=""><i class="fas fa-key mt-1" style={{color:'#c0392b'}}></i></span>
                                </div>
                                <input type="password" name="" onChange={(e) => { setPassword(e.target.value) }} class="form-control input_pass" placeholder="Password" />
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    {/* <input type="checkbox" class="custom-control-input" id="customControlInline"/> */}
                                    <label class="custom-control-label"></label>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3 login_container">
                                <button type="submit" name="button" class="btn login_btn">Login</button>
                            </div>
                        </form>
                    </div>

                    <div class="mt-2">
                        <div class="d-flex justify-content-center links">
                            <a href="#">Forgot your password?</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='image_Container col-md-8  p-0'>
                <img src={gymImage}  className='' alt="" />
            </div>
            </div>
            </div>


        </div>
    );
 
};

// export default Login;

const mapStateToProps = (state) => {
    return {
        logged_in: state.logged_in,
        counter: state.counter
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        loggMeIN: (data) => dispatch(loggMeIN(data)),
        setAuth: (data) => dispatch(setAuth(data)),
        setRole: (data) => dispatch(setRole(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);